@if (loadPage) {
	<main>
		@if (historicData && historicData.length) {
			<div>
				@for (item of historicData; track item) {
					<div class="data-task-comment">
						<div>{{ item.taskLabel }}</div>
						<div>{{ item.data }}</div>
					</div>
					<lbca-comment-forum-textarea
						[lines]="3"
						[disabled]="true"
						[user]="item.userFullName"
						[inputValue]="item.content"
					></lbca-comment-forum-textarea>
					@if (item.file && item.fileConfig) {
						<lbca-files-download
							[disabled]="true"
							[configuration]="item.fileConfig"
							[cardData]="cardInfo"
							[context]="item"
						></lbca-files-download>
					}
				}
			</div>
		}
		@if (!(isDisabled && !editData)) {
			<div class="data-task-comment"></div>
			<lbca-comment-forum-textarea
				[require]="isRequired"
				[disabled]="isDisabled"
				[label]="labelValue"
				[helperText]="helperTextValue"
				[error]="err"
				[user]="editData?.userFullName"
				[inputValue]="editData?.content"
				(focusState)="textAreaFocus($event)"
				(setError)="emmitError($event)"
				(validStatus)="emmitValid($event)"
				(changeValue)="emmitChange($event)"
			></lbca-comment-forum-textarea>
			@if (config.fileUpload) {
				<lbca-sub-module-file-upload
					[idEntity]="fileUploadConfig.entityKey"
					[value]="file"
					[label]="fileUploadConfig.label"
					[dataAttr]="dataAttr"
					[cardData]="cardInfo"
					(saveValue)="saveUpload($event)"
					[properties]="fileUploadConfig"
				></lbca-sub-module-file-upload>
			}
		}
	</main>
}
